import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { FormGroupState } from 'ngrx-forms'
import { Observable } from 'rxjs'
import { selectAddressState } from '../user-addresses.state'
import { CanDeactivateDirective } from '../../../utils/can-deactivate.directive'
import { Address } from '../../user-profile/user-profile.state'

@Component({
  selector: 'cover-new-address',
  templateUrl: './new-address.component.html',
  styleUrls: ['./new-address.component.scss'],
})
export class NewAddressComponent extends CanDeactivateDirective {
  formState$: Observable<FormGroupState<Address>>

  constructor(private readonly store: Store) {
    super()
    this.formState$ = store.select(selectAddressState.newAddressControls)
  }
}
